type PersonName = {
    firstName?: string | null
    lastName?: string | null
}

const isGocAssistant = (participant: PersonName): boolean => {
    const firstName = (participant.firstName ?? '').trim()
    const lastName = (participant.lastName ?? '').trim()
    const name = `${firstName} ${lastName}`.toLowerCase().trim()
    return name === 'goc assistant' || name.startsWith('goc assistant ')
}

export { isGocAssistant }
